export const templatesList = [
  "clean",
  "minimal",
  "pure",
  // "bold",
  "classic",
  "split",
  "confidence",
  "creative",
  "essential",
  "elegance",
  // "elegant",
  "executive",
  "feminine",
  "bold",
  "framed",
  "horizon",
  // "impact",
  "sidebar",
  "simple",
  "leafish",
  "vibrant",
  "traditional",
  "accent",
  "compact",
  "metro",
  "modern",
  "modern-refined",
  "influx",
  "newcast",
  "nexus",
  "grid",
  "onyx",
  "highlight",
  "straight",
  "rayhan",
  "slate",
  "pinnacle",
  "zenith",
  "ethereal",
  "aura",
  "prism",
  "axiom",
  "vortex",
  "editorial",
  "architect",
  "modernist",
  "studio",
  "folio",
  "cipher",
  "apex",
  "corsa",
  // "tech",
] as const;

export type Template = (typeof templatesList)[number];
